import { ElementType, ReactNode } from "react";

import { BodyLG } from "./BodyLG";
import { cn } from "@verse_core/shared_components/ClassName";

type BodyProps = {
  children: ReactNode;
  className?: string;
  dataTestId?: string;
  as?: ElementType;
};

export const BodyLGB = ({
  children,
  className,
  as: Component = "p",
  dataTestId,
}: BodyProps) => {
  return (
    <BodyLG
      className={cn("tw-font-medium", className)}
      as={Component}
      dataTestId={dataTestId}
    >
      {children}
    </BodyLG>
  );
};
